import { render, staticRenderFns } from "./PaymentsReduced.vue?vue&type=template&id=eb4d83e0&scoped=true&"
var script = {}
import style0 from "./PaymentsReduced.vue?vue&type=style&index=0&id=eb4d83e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4d83e0",
  null
  
)

export default component.exports